import meta from "../common/meta.json";
import TopicData from "../../data/Topics.json";

const SUPPORTED_LOCALES = require("../../config/config").SUPPORTED_LOCALES;

export const getRouterBase = () => {
    //China domain
    if (location.host.includes(".cn")) {
        return "/";
    }
    return `${location.pathname.slice(0, 6)}/`;
};

export const getVoltronBase = () => {
    if (isCNTLD()) {
        return VOLTRON_BASE_CN;
    }
    return VOLTRON_BASE;
};

export const getStarfleetBase = () => {
    if (isCNTLD()) {
        return STARFLEET_BASE_CN;
    }
    return STARFLEET_BASE;
};

export const isCNTLD = () => {
    return location.host.includes(".cn");
};

export const isCOMTLD = () => {
    return location.host.includes(".com");
};

export const extractPreferencesPathname = (pathname) => {
    const match = pathname.match(/\/preferences\/(.*)/);
    if (match && match[0]) {
        return match[0];
    }
    return "/preferences/start/";
};

export const getCookie = (name) => {
    const cookieArr = document.cookie.split(";");

    for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].split("=");
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }

    return "";
};

export const getClientId = (isAccount) => {
    if (isCNTLD()) {
        return isAccount ? ACCOUNT_CLIENT_ID_CN : CLIENT_ID_CN;
    } else {
        return isAccount ? ACCOUNT_CLIENT_ID : CLIENT_ID;
    }
};

export const getExpirationDate = (validity) => {
    let expirationDate = new Date();
    expirationDate = new Date(expirationDate.getTime() + validity * 1000);
    return expirationDate;
};

export const getLocale = () => {
    if (location.host.includes(".cn")) {
        return "zh-cn";
    }
    return location.pathname.slice(1, 6);
};

export const convertLocaleFormat = (locale, format) => {
    if (!locale) {
        return "";
    }

    // first normalize the separator for split
    const localeSplit = setLocaleSeparator(locale, "-").split("-");

    switch (format) {
        case "xx_XX":
            return `${localeSplit[0].toLowerCase()}_${localeSplit[1].toUpperCase()}`;
        case "xx-xx":
        default:
            return `${localeSplit[0]}-${localeSplit[1]}`.toLowerCase();
    }
};

const setLocaleSeparator = (locale, separator) => {
    return locale.replace(/-|_/g, separator);
};

export const getLocalePath = (locale) => {
    if (location.host.includes(".cn")) {
        return "";
    }
    return `/${locale}`;
};

export const validateEmail = (email, format) => {
    const emailRefex = new RegExp(format);
    return emailRefex.test(email);
};

export const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isAccountPage = (pathname) => {
    let basePath = pathname.split("/")[1];
    return basePath === "account";
};

export const translate = (array, t) => {
    return array.map((obj) => {
        return {
            value: obj.value,
            label: t(obj.label),
        };
    });
};

export const convertEUPResponse = (resp) => {
    return resp.map((x) => {
        return {
            label: x.tagName,
            value: x.machineName,
        };
    });
};

export const removePageMetaDescription = () => {
    document.querySelectorAll("meta[name=description]").forEach((meta) => {
        meta.remove();
    });
};

export const removeCanonicalTags = () => {
    document.querySelectorAll("link[rel=alternate]").forEach((link) => {
        link.remove();
    });
    document.querySelectorAll("link[rel=canonical]").forEach((link) => {
        link.remove();
    });
};

export const addPageMetaDescription = (page) => {
    removePageMetaDescription();
    let pageLocale = getLocale();
    let metaElement = document.createElement("meta");
    metaElement.name = "description";
    metaElement.content = pageLocale in meta ? meta[pageLocale][page] : meta["en-us"][page];
    document.head.appendChild(metaElement);
};

export const addCanonicalTags = (page) => {
    // load canonical tags
    removeCanonicalTags();
    let pageLocale = getLocale();
    SUPPORTED_LOCALES.map((locale) => {
        let linkElement = document.createElement("link");
        linkElement.href = `https://www.nvidia.com/${locale}/preferences/${page}/`;
        if (locale === pageLocale) {
            linkElement.rel = "canonical";
        } else {
            linkElement.rel = "alternate";
            linkElement.hreflang = locale;
        }
        document.head.append(linkElement);
    });

    let defualtElement = document.createElement("link");
    defualtElement.href = `https://www.nvidia.com/en-us/preferences/${page}/`;
    defualtElement.hreflang = "x-default";
    defualtElement.rel = "alternate";
    document.head.append(defualtElement);
};

export const setCookie = (value, cookieName) => {
    document.cookie = `${cookieName}=${value}; expires=${new Date(
        new Date().getTime() + 365 * 24 * 60 * 60 * 1000
    ).toUTCString()}; domain=${
        isCNTLD() ? FIRST_PARTY_TOKEN_COOKIE_DOMAIN_CN : FIRST_PARTY_TOKEN_COOKIE_DOMAIN
    }; path=/`;
};

export const expireCookie = (cookieName) => {
    // setting max-age=0 will expire a cookie
    document.cookie = `${cookieName}=; max-age=0; domain=${
        isCNTLD() ? FIRST_PARTY_TOKEN_COOKIE_DOMAIN_CN : FIRST_PARTY_TOKEN_COOKIE_DOMAIN
    }; path=/`;
};

export const loadAdobeDTM = () => {
    // Load Adobe DTM script
    if (!document.getElementById("adobe-dtm-header")) {
        const headerScript = document.createElement("script");
        headerScript.src = ADOBE_DTM_SCRIPT;
        headerScript.setAttribute("id", "adobe-dtm-header");
        document.head.appendChild(headerScript);
    }
    if (!document.getElementById("adobe-dtm-footer")) {
        const footerScript = document.createElement("script");
        footerScript.setAttribute("type", "text/javascript");
        footerScript.text = `window.addEventListener("load", () => {
            _satellite.pageBottom();
        });`;
        footerScript.setAttribute("id", "adobe-dtm-footer");
        document.body.appendChild(footerScript);
    }
};

export const loadOneTrustSnippet = () => {
    // Load OneTrust snippet
    if (!document.getElementById("onetrust-snippet")) {
        const script = document.createElement("script");
        script.src = ONE_TRUST_SNIPPET_SCRIPT;
        script.setAttribute("data-document-language", true);
        script.type = "text/javascript";
        script.charset = "UTF-8";
        script.setAttribute("data-domain-script", ONE_TRUST_SNIPPET_DOMAIN);
        script.setAttribute("id", "onetrust-snippet");
        document.head.appendChild(script);
    }
    if (!document.getElementById("onetrust-snippet-2")) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.setAttribute("id", "onetrust-snippet-2");
        script.text = `
            function OptanonWrapper() {        
                var event = new Event('bannerLoaded');
                window.dispatchEvent(event);
            }
        `;
        document.head.appendChild(script);
    }
    if (!document.getElementById("onetrust-snippet-3")) {
        const script = document.createElement("script");
        script.src = ONE_TRUST_SNIPPET_CUSTOM_SCRIPT;
        script.type = "text/javascript";
        script.setAttribute("id", "onetrust-snippet-3");
        document.head.appendChild(script);
    }
};

export const detectGpcSignal = () => {
    return document.cookie?.includes("isGpcEnabled=1") || navigator.globalPrivacyControl;
};

export const getInitialEmailablesSettings = (t) => {
    const initialEmailables = {};
    TopicData.emailables.forEach((item) => {
        initialEmailables[item.id] = {
            subscribed: false,
            optInSentence: t(item.note),
        };
    });
    return initialEmailables;
};

export const getInitialDataSharingSettings = (t) => {
    const initialDataSharing = {};
    TopicData.dataSharing.forEach((item) => {
        initialDataSharing[item.id] = {
            subscribed: false,
            optInSentence: t(item.note, {
                SHARE_MY_DETAILS: `${t("share my details")}`,
                interpolation: { escapeValue: false },
            }),
        };
    });
    return initialDataSharing;
};

export const checkChinaPIIConsent = (countryCode, chCollection, chStorage) => {
    if (isCNTLD()) {
        return chCollection;
    } else if (countryCode === "CN" && isCOMTLD()) {
        return chStorage;
    }
    return true;
};

export const userHasAccount = () => {
    if (
        localStorage.getItem("acctFederationData") === null &&
        localStorage.getItem("prvyFedarationData") === null
    ) {
        return false;
    }
    return true;
};
